export default __webpack_public_path__ + "static/media/apache-svgrepo-com.8abe5f19.svg";